/**
 * Shared Utilities
 * Common helper functions used across packages
 */

/**
 * Strip undefined values from object (Pydantic v2 extra='forbid' defense)
 * Backend will reject any field with undefined value - must be omitted entirely
 */
export function stripUndefined<T extends Record<string, unknown>>(obj: T): T {
  const result = {} as T;
  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined) {
      (result as Record<string, unknown>)[key] = value;
    }
  }
  return result;
}

/**
 * Deep strip undefined from nested objects and arrays
 */
export function deepStripUndefined<T>(value: T): T {
  if (value === null || value === undefined) {
    return value;
  }
  
  if (Array.isArray(value)) {
    return value.map(deepStripUndefined) as T;
  }
  
  if (typeof value === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
      if (val !== undefined) {
        result[key] = deepStripUndefined(val);
      }
    }
    return result as T;
  }
  
  return value;
}

export * from './audioController';